<template>
  
  <div class="bg-white padding">
    <div>
      <div class="input-item flex">
        <div style="display: flex" class="text-nowrap">
          <div class="line"></div>
          請輸入車號
        </div>
      </div>
      <div class="form">      
        <div class="item">
          <div class="field">
            車號
            <span class="text-gray2">（範例：ABC-8888 或 8888-ABC）</span>
          </div>
          <div class="cardNumber">
            <input v-model.trim="number0" name="number0" maxlength="4" ref="number0" @focus="inFocus = true" @keyup="changeNumber0" @blur="inFocus = false" />
            <span class="space-line"></span>
            <input v-model.trim="number1" name="number1" maxlength="4" ref="number1" @focus="inFocus = true" @keyup="changeNumber1" @blur="inFocus = false" />
          </div>
        </div>      
      </div>
      <br>
      <div class="input-item flex">
        <div style="display: flex" class="text-nowrap">
          <div class="line"></div>
          請輸入車主資訊
        </div>
      </div>
      <div class="form">      
        <div class="item">
          <div class="field">
            身分證字號/統一編號
          </div>
          <div>
            <input type="text" name="userId" placeholder="請輸入身分證字號/統一編號" class="input" v-model="userId" @focus="idInFocus = true" @keyup="changeIDNumber" @blur="idInFocus = false" />
            <div class="border-bottom" :style="idBorderStyle"></div>
            <div class="required" v-if="!isUserIdVerified">身分證填寫錯誤！</div>
          </div>
        </div>      
      </div>
      <button class="btn btn-primary" id="search-btn" :disabled="searchBtnDisable" ref="search_btn" @click="getBill">查詢待繳帳單</button>
    </div>
    <div class="description">      
      <ul class="text-gray2">
        <li>每筆汽燃費逾期繳納罰鍰帳單繳費需收取13元手續費；請勿重複繳費，重複繳費之手續費不予退還。</li>
        <li>可使用悠遊付錢包、銀行帳戶連結、信用卡(<span class="text-blue">限台新銀行、玉山銀行發卡</span>)進行繳費扣款。</li>
        <li>一次查詢最多顯示50筆；每周三20:00~21:00公路局系統維護，暫停服務。</li>
        <li>繳費收據可至「監理服務網》汽機車》燃料費》繳費記錄及列印」列印。</li>
        <li>本服務為汽燃費線上繳費：自用汽機車於每年7月徵收；營業汽車於每年3、6、9、12月徵收；不支援4月份開徵之牌照稅查詢繳費。</li>
        <li>請確認付款資訊無誤，交易完成後即無法取消。</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { checkID } from '../../utils/verify-id';
import { queryBillList } from '../../api/api';
import { mapActions } from 'vuex';
export default {
  name: 'car-fine',
  data() {
    return {
      carNumber0: '',
      carNumber1: '',
      userId: '',
      idInFocus: false,
      inFocus: false,
      isUserIdVerified: true,
    };
  },
  mounted() {
    //this.$refs.number0.focus();
  },
  activated() {
    //this.$refs.number0.focus();
  },
  methods: {
    ...mapActions(['setReadyToPayBill']),
    changeNumber0(e) {
      e.target.value = e.target.value.replace(/[\W]/g, '');
      if (this.number0.length >= 4) {
        this.$refs.number1.focus();
      }
    },
    changeNumber1(e) {
      e.target.value = e.target.value.replace(/[\W]/g, '');
      if (this.number1.length >= 4) {
        this.$refs.number1.blur();
      }
    },
    changeIDNumber(e) {
      e.target.value = e.target.value.replace(/[\W]/g, '');
      if (e.target.value.length >= 10) {
        e.target.blur();
      }
    },
    getBill() {
     
      var form = {
        payment_item_id: 'TWNCH-0309',
        payment_query_type: 'REALTIME-1',
        parameter1: this.carNumber0 + '-' + this.carNumber1,
        parameter2: this.userId.toUpperCase(),
        parameter3: '',
        payment_custom_id: '',
      };
       
      queryBillList(form).then((res) => {
        if (res.error === undefined || res.error === null) {
          this.setReadyToPayBill(res);
          this.searchBill(form);
        } else {
          alert(res.error.message);
        }
      });
    },
    searchBill(form) {
      this.$router.push({
        path: '/goPay',
        query: form,
      });
    },
  },
  computed: {
    searchBtnDisable() {
      return this.userId === '' || this.carNumber0 === '' || this.carNumber1 === '';
    },
    userId: {
      get: function () {
        return this.userId;
      },
      set: function (val) {
        this.userId = val.toUpperCase();
      },
    },
    isDisabled() {
      return this.carNumber0 === '' || this.carNumber1 === '' || this.userId === '';
    },
    number0: {
      get: function () {
        return this.carNumber0;
      },
      set: function (val) {
        this.carNumber0 = val.toUpperCase().replace(/\s/g, '');
      },
    },
    number1: {
      get: function () {
        return this.carNumber1;
      },
      set: function (val) {
        this.carNumber1 = val.toUpperCase().replace(/\s/g, '');
      },
    },
    idBorderStyle() {
      if (this.idInFocus) {
        return 'background: #007ac8';
      } else {
        return 'background: #c7c7c7';
      }
    },
  },
};
</script>

<style scoped>
.form .item {
  margin-top: 24pt;
}

.cardNumber {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.cardNumber input {
  background: rgba(64, 64, 64, 0.05);
  border: none;
  font-size: 16px;
  line-height: 30px;
  padding: 11pt 0;
  width: 50%;
  text-align: center;
}

.space-line {
  margin: 0 8pt;
  background: #000;
  height: 1px;
  content: '';
  display: block;
  width: 20pt;
}

.description {
  margin-top: 32px;
}

#search-btn {
  margin-top: 40px;
}
</style>
